import { BasisTheoryProvider as BasisTheoryProviderBase, useBasisTheory } from '@basis-theory/react-elements'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { AlertCircle } from 'lucide-react'
import { LoadingSpinner } from '../loading-spinner'

const BT_PUBLIC_KEY = import.meta.env.VITE_BASIS_THEORY_API_KEY
if (!BT_PUBLIC_KEY) {
  throw new Error('VITE_BASIS_THEORY_API_KEY is not set')
}

export function BasisTheoryProvider({ children }: { children: React.ReactNode }): React.ReactNode {
  const { bt, error } = useBasisTheory(BT_PUBLIC_KEY)

  if (error) {
    console.error('Basis Theory error:', error)
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <Card className="w-full max-w-md shadow-lg">
          <CardHeader className="bg-red-50 text-red-800 rounded-t-lg">
            <CardTitle className="flex items-center">
              <AlertCircle className="mr-2 h-5 w-5" />
              Payment Form Error
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <p>
              We're having trouble loading the payment form right now. Please try refreshing the page or contact support
              if the problem persists.
            </p>
          </CardContent>
        </Card>
      </div>
    )
  }
  if (!bt) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <LoadingSpinner />
      </div>
    )
  }
  return <BasisTheoryProviderBase bt={bt}>{children}</BasisTheoryProviderBase>
}
